import React from 'react'
import SingleField from '../single-field'

import './style.scss'

const Index = ({parseData}) => {
    return(
        <div className="csv-configuration-container">
            <p className="configuration-description">Gå gjennom hvert enkelt felt hentet fra CSV-filen du lastet opp og velg riktig datatype i skjemaet nedenfor.</p>
            <div className="configuration-list-wrapper">
                {parseData && parseData.meta && parseData.meta.fields && parseData.meta.fields.map((name) => {
                    return(
                        <SingleField title={name}/>
                    )
                })}
            </div>
        </div>
    )
}

export default Index